/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { FixedAssetsDepreciationService } from "services/fixed-assets-depreciation-schedule";

const renderData = (items, setDataTable) => {
  return items.map((item) => ({
    id: item._id,
    documentNumber: item.documentNumber,
    year: item.year,
    month: item.month,
    unit: item.unit,
    department: item.department,
    signingDate: item.signingDate ? formatDate(item.signingDate) : "",
    totalDepreciation: item.total?.entireEnterprise?.depreciationAmount
      ? formatCurrency.format(item.total.entireEnterprise.depreciationAmount)
      : "0",
    createdAt: formatDate(item.createdAt),
    action: <ActionCell item={item} index={item._id} setDataTable={setDataTable} />,
  }));
};

const tableData = {
  columns: [
    {
      Header: "Số",
      accessor: "documentNumber",
    },
    {
      Header: "Năm",
      accessor: "year",
    },
    {
      Header: "Tháng",
      accessor: "month",
      width: "10%",
    },
    {
      Header: "Đơn vị",
      accessor: "unit",
      width: "20%",
    },
    {
      Header: "Bộ phận",
      accessor: "department",
      width: "15%",
    },
    {
      Header: "Tổng khấu hao",
      accessor: "totalDepreciation",
      width: "15%",
    },
    {
      Header: "Ngày ký",
      accessor: "signingDate",
    },
    {
      Header: "Ngày tạo",
      accessor: "createdAt",
    },
    { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

function FixedAssetsDepreciationSchedule() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await FixedAssetsDepreciationService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate, paginate } = response.data || response;
      setCheckCreate(checkCreate ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu bảng khấu hao TSCĐ:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default FixedAssetsDepreciationSchedule;
